<template>
  <v-app>
    <v-content>
      <v-container fluid :class="'pa-0' + ($config.id === 2 ? ' skin-id2' : '')">
        <div class="all-yellow-wrapper">
          <Header />
          <v-fade-transition hide-on-leave>
            <router-view></router-view>
          </v-fade-transition>
          <Footer />
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
/**
 * App
 */
import { mapState, mapGetters } from "vuex";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DaFadeTransition from "~~/components/transitions/DaFadeTransition.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    DaFadeTransition,
  },
  created() {
    this.$store.dispatch("fetchCat", {});
    this.vLocalize();
  },
  data() {
    return {};
  },
  methods: {
    vLocalize() {
      const labels = {
        name: "Имя",
        firstname: "Имя",
        surname: "Фамилия",
        phoneNumbers: "Телефон",
        linkEmails: "E-mail",
      };
      this.validationLocalize(labels);
    },
  },
  computed: {
    ...mapState(["loading", "cat"]),
    ...mapGetters(["validationLocalize"]),
  },
};
</script>

<style lang="scss">
@import "../src/assets/global.scss";
</style>
